import { Component, OnInit } from '@angular/core';
import { TestPageService } from './test-page.service';

@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit {
  
  title = 'Dashboard Health';
  ports: any;

  constructor(private testPageService: TestPageService) {
  }

  ngOnInit() {
    this.ports = {};
    this.runPortChecks();
  }


  runPortChecks(): any {

    this.checkPort443Https();
    this.checkWssMQTT443Status();
    this.checkMQTT8443Status();
    this.checkHttp80tatus();

  }

  checkPort443Https() {

    this.ports.https443Status = 'Validating...';
    this.testPageService.checkPort443Https()
    .then(result =>  {
      if (result === 'success') {
        this.ports.https443Status = 'Passed';
      } else {
        this.ports.https443Status = 'Unexpected response: ' + result;
      }
    })
    .catch(error => {
      console.log(JSON.stringify(error));
      this.ports.https443Status = 'failed: ' + error.message;
    })
  }

  checkHttp80tatus(): any {

    this.ports.http80tatus = 'Validating...';
    this.ports.http80tatus = 'Test not implemented'
    // this.testPageService.checkPort80Http()
    // .then( result => {
    //   this.ports.http80tatus = 'Passed';
    // }) 
    // .catch((error) => {
    //   this.ports.http80tatus = 'failed: ' + error.message;
    //  });
  }

  checkMQTT8443Status(): any {
    this.ports.mQTT8443Status = 'Validating...';
    this.ports.mQTT8443Status = 'Test not implemented';
  }
  checkWssMQTT443Status(): any {
    this.ports.wssMQTT443Status = 'Validating...';
    this.ports.wssMQTT443Status = 'Test not implemented';
  }

  public getCellColor(warningLevel: string): string {
    let color = 'black';
    switch (warningLevel) {
      case 'Passed': {
        color = 'green';
        break;
      }
      case 'Medium': {
        color = 'orange';
        break;
      }
      case 'Failed': {
        color = 'red';
        break;
      }
      default: {
        color = 'orange';
        break;
      }
    }

    return color;

  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/test-page/test-page.component.ts